export default __webpack_public_path__ + "static/media/rowSeat_mockup_dark.10584a7c.svg";